import { render, staticRenderFns } from "./social-drawer.vue?vue&type=template&id=07f6b58c&scoped=true&"
import script from "./social-drawer.vue?vue&type=script&lang=js&"
export * from "./social-drawer.vue?vue&type=script&lang=js&"
import style0 from "./social-drawer.vue?vue&type=style&index=0&id=07f6b58c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f6b58c",
  null
  
)

export default component.exports